export default (theme) => ({
    root: {
        marginTop: 40,
        padding: 0,
    },
    values: {
        marginTop: 0,
    },
    valueList: {
        marginTop: 20,
        marginBottom: 10,
        '& > div:focus': {
            outline: 'none',
        },
    },
    emptyContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 20,
        height: 120,
        backgroundColor: theme.colors.actionMinor[50],
        border: `dashed 1px ${theme.colors.grey[100]}`,
        borderRadius: 5,
        '& > *': {
            margin: '0 2.5px',
        },
    },
    showMoreContainer: {
        paddingTop: '15px',
        textAlign: 'center',
    },
    toolbar: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    toolbarSearch: {
        width: '50%',
        marginRight: 'auto',
        padding: 0,
    },
    generalLoader: {
        textAlign: 'center',
    },
    initLoader: {
        textAlign: 'center',
        padding: '1rem',
    },
    valueListValueTable: {
        marginTop: '10px',
        height: '500px',
    },
    iconDisabled: {
        opacity: 0.5,
        cursor: 'not-allowed',
    },
});
